import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/store';
import './registerServiceWorker';
import { library } from '@fortawesome/fontawesome-svg-core';
import VeeValidate from 'vee-validate';
import Fragment from 'vue-fragment';
import Toasted from 'vue-toasted';
import VueI18n from 'vue-i18n';
import { i18n } from './translations/index.js';

const toastOptions = {
  theme: 'toasted-primary',
  position: 'top-center',
  duration: 2500
};

import 'bootstrap';

import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(far, fas);

window.$ = window.jQuery = require('jquery');

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VeeValidate);
Vue.use(VueI18n);
// Vue.use(VuePageTransition);
Vue.use(Fragment.Plugin);
Vue.config.productionTip = false;
Vue.use(Toasted, toastOptions);

new Vue({
  router,
  i18n,
  store,
  render: function(h) {
    return h(App);
  }
}).$mount('#app');
